import ClickOutsideListener from "./ClickOutsideListener";

export default ClickOutsideListener;
try {
    // @ts-ignore
    ClickOutsideListener.displayName = "ClickOutsideListener";
    // @ts-ignore
    ClickOutsideListener.__docgenInfo = { "description": "", "displayName": "ClickOutsideListener", "props": { "clickOutside": { "defaultValue": null, "description": "", "name": "clickOutside", "required": true, "type": { "name": "(event: any) => void" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/hoc/ClickOutsideListener/index.ts#ClickOutsideListener"] = { docgenInfo: ClickOutsideListener.__docgenInfo, name: "ClickOutsideListener", path: "src/shared/hoc/ClickOutsideListener/index.ts#ClickOutsideListener" };
}
catch (__react_docgen_typescript_loader_error) { }